import { EvtHeader } from "components/header";
import CompanyForm from "@/modules/crm/companies/crud/form";
import React from "react";

const CreateCompany = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Company" />
      <div className="p-6 max-w-2xl">
        <CompanyForm />
      </div>
    </div>
  );
};

export default CreateCompany;
